'use client';

import * as types from '../../types';
import styles from './Burger.module.scss';

export function Burger({ open, setOpen }: types.Burger): JSX.Element {
  return (
    <button
      className={`${styles.burger} ${open ? styles['burger--open'] : ''}`}
      onClick={() => setOpen(!open)}
      aria-label="Main menu"
      type="button"
      id="menu-button"
    >
      <div />
      <div />
      <div />
    </button>
  );
}
